import authRequest from "@/api/http/authRequest";
import axios from "axios";


export default {
  search (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.get(`/admin/access-code-payment-audits`, params, cb, errCb)
  },
  getCount (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.get(`/admin/access-code-payment-audits/count`, params, cb, errCb)
  },
  upload (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.post(`/admin/access-code-payment-audits`, params ,cb, errCb)
  },
  save (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.post(`/admin/access-code-payment-audit/${params.accessCodePaymentType}/${params.accessCode}`, params ,cb, errCb)
  },
  delete(id: number, cb: (response) => void, errCb: (response) => any) {
    authRequest.delete(`/admin/access-code-payment-audit/${id}` ,cb, errCb)
  },
  reset(id: number, cb: (response) => void, errCb: (response) => any) {
    authRequest.patch(`/admin/access-code-payment-audit/${id}`, {} ,cb, errCb)
  },
  download (params: any, cb: (response) => void, errCb: (response) => any) {
    const accessToken = localStorage.ACCESS_TOKEN
    const payloadString = Object.entries(params).map(e => e.join('=')).join('&');
    axios({
      method: 'get',
      url: `${process.env.VUE_APP_API}/admin/access-code-payment-audits/excel?${payloadString}`,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).then(cb)
      .catch(errCb)
  },
}
